import { render, staticRenderFns } from "./ContextMenuClickNotClose.vue?vue&type=template&id=c226d8a2&"
import script from "./ContextMenuClickNotClose.vue?vue&type=script&lang=js&"
export * from "./ContextMenuClickNotClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports